// import _ from 'lodash'
// import axios from 'axios'
import { getCookie, setCookie } from '@/helpers'
import VueJwtDecode from 'vue-jwt-decode'

const state = {
    customer: null,
    exp: null,
    cartAmount: null,
    cartExp: null,
}
const mutations = {
    setCustomer (state, customer) {
        state.customer = customer.name
        state.exp = customer.exp
    },
    setCart (state, cart) {
      console.log('setCart', cart, state)
      state.cartExp = cart.cartExp
      state.cartAmount = cart.cartAmount
    },
    deleteCustomer(state){
        state.customer = null
        state.exp = null
    },
}

export const actions = {

    async loadCustomer ({ commit }) {
        const now = new Date().getTime() / 1000;
        let jwt_cookie = getCookie('customerStatus')
        if (jwt_cookie) {
            const data = VueJwtDecode.decode(jwt_cookie)
            if (data.exp && now < data.exp) {
                commit('setCustomer', data)
            } else {
                commit('deleteCustomer')
            }
        }
        else {
                commit('deleteCustomer')
            }
    },

    async saveGuestStatus() {
      let isGuest = false
      let guestText = document.querySelector('.evt-mobile-shortcut-navigation-link.dropdown-toggle > .hidden-xs')
      if(guestText !== null){
        isGuest = guestText.textContent === 'Gast' || guestText.textContent === 'Guest'
        if (isGuest) {
          setCookie('isGuestUser', isGuest)
         }
      }
      return isGuest
    },

    async getCartFromCookie({ commit }) {
      let cart =  getCookie('cartAmount')
      let cartAmount = 0
      let cartExp = null
      if(cart !== null){
        cartAmount = parseInt(cart.split('|')[0], 10)
        cartExp = parseInt(cart.split('|')[1], 10)
        if (!isNaN(cartAmount) && !isNaN(cartAmount) && cartExp > Date.now()){
          if (cartAmount > 99) {
            cartAmount = 99
          }
        }
        else {
          cartAmount = 0
          cartExp = null
        }
      }
      commit ('setCart', {cartAmount: cartAmount, cartExp: cartExp})
      return {cartAmount: cartAmount, cartExp: cartExp}
    },

    async saveCartToCookie({commit, dispatch}) {
      let currentCart = await dispatch('getCartFromCookie')

      let cartAmount = 0
      let badge = document.querySelector('#nav_shoppingcart .badge')
      if(badge !== null){
        cartAmount = parseInt(badge.textContent, 10)
        if(isNaN(cartAmount)){
          cartAmount = 0
        }
      }
      console.log('cartAmount', cartAmount)
      if (document.querySelector('#nav_shoppingcart') !== null && currentCart.cartAmount !== cartAmount) {
          console.log('currentCartAmount !== cartAmount')
        let cartExp = Date.now() + 15*60*1000
        commit('setCart', {cartAmount: cartAmount, cartExp: cartExp})
        setCookie('cartAmount', cartAmount+'|'+cartExp)
      }
    },

    async deleteCustomCookies() {
      setCookie('cartAmount', '')
      setCookie('isGuestUser', '')
    },

}

export const getters = {
    isLoggedIn: state => () => {
        return state.customer && state.exp && state.exp > Date.now() / 1000
    },
    isGuest: () => {
        return getCookie('isGuestUser') === 'true'
    },
    hasCartItems: state => {
        console.log('hasCartItems', state)
        return state.cartAmount > 0 && state.cartExp > Date.now()
    },
    customerName: state => {
        return state.customer
    }
}

export default {
    state,
    mutations,
    getters,
    actions,
}